'use client';

import { Button } from '@depop/web-ui-kit/Button';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { ExtendedLink } from '@/components/ExtendedLink';
import { Hero } from '@/components/Hero';
import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { useSellNowHref } from '@/modules/signup/hooks/useSellNowHref';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export function TopSellerHero() {
  const t = useTranslations('topSellerProgram');
  const { sendActivityTrackerEvent } = useActivityTracker();
  const [isAuthenticated] = useCurrentUser();
  const { href: sellNowHref } = useSellNowHref();
  const href = isAuthenticated ? '/sellinghub/drafts/' : sellNowHref;

  function handleSellNow() {
    sendActivityTrackerEvent(ActivityTrackerEventType.CTA_ACTION, {
      type: 'top_seller_hero_signup',
      schemaVersion: '2.0',
    });
  }

  return (
    <Hero
      desktopImage={{
        src: `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/topSellerProgram/hero-collage-desktop.webp`,
        alt: t('Hero.CollageAlt'),
      }}
      mobileImage={{
        src: `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/topSellerProgram/hero-collage-mobile.webp`,
        alt: t('Hero.CollageAlt'),
      }}
      badge={
        <img
          className={styles.badgeLogo}
          src={`${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/topSellerProgram/depop-top-seller-stamp.svg`}
          alt={t('Hero.BadgeAlt')}
        />
      }
      heading={t.rich('Hero.Heading', {
        br: () => <br />,
      })}
      description={t.rich('Hero.Description', {
        bold: (chunks) => <strong>{chunks}</strong>,
      })}
    >
      <ExtendedLink
        href={href}
        className={styles.ctaLink}
        onClick={handleSellNow}
      >
        <Button as="span" className={styles.ctaButton}>
          {t('Hero.CTA')}
        </Button>
      </ExtendedLink>
    </Hero>
  );
}
